import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';
import ChatWidget from '../components/common/ChatWidget';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-slate-900 mb-8">Datenschutzerklärung</h1>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Datenschutz auf einen Blick</h2>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Allgemeine Hinweise</h3>
                <p className="text-slate-600 mb-4">
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
                  Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                  denen Sie persönlich identifiziert werden können.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Verantwortliche Stelle</h2>
                <p className="text-slate-600">
                  {companyInfo.legal.company}<br />
                  {companyInfo.address.street}<br />
                  {companyInfo.address.zip} {companyInfo.address.city}<br /><br />
                  Telefon: {companyInfo.contact.phone}<br />
                  E-Mail: {companyInfo.contact.email}
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Datenerfassung auf dieser Website</h2>
                
                <h3 className="text-lg font-medium text-slate-800 mb-2">Cookies</h3>
                <p className="text-slate-600 mb-4">
                  Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und 
                  richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer 
                  einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
                </p>

                <h3 className="text-lg font-medium text-slate-800 mb-2">Kontaktformular</h3>
                <p className="text-slate-600 mb-4">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                  Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                  der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                </p>

                <h3 className="text-lg font-medium text-slate-800 mb-2">Anfrage zur Finanzierung</h3>
                <p className="text-slate-600">
                  Bei der Nutzung unseres Finanzierungsanfrage-Formulars erheben wir folgende Daten:
                </p>
                <ul className="list-disc list-inside text-slate-600 mt-2 space-y-1">
                  <li>Name und Anschrift</li>
                  <li>E-Mail-Adresse und Telefonnummer</li>
                  <li>Gewünschte Finanzierungssumme und Laufzeit</li>
                  <li>Angaben zu Einkommen und Beschäftigung</li>
                  <li>Angaben zu bestehenden Verbindlichkeiten</li>
                </ul>
                <p className="text-slate-600 mt-4">
                  Diese Daten werden ausschließlich zur Bearbeitung Ihrer Finanzierungsanfrage verwendet und 
                  an die von Ihnen ausgewählten Partnerbanken weitergeleitet.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Ihre Rechte</h2>
                <p className="text-slate-600 mb-4">
                  Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten 
                  personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung 
                  sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                </p>
                <p className="text-slate-600">
                  Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit 
                  an uns wenden.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Datensicherheit</h2>
                <p className="text-slate-600">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, 
                  wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine 
                  SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die 
                  Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in 
                  Ihrer Browserzeile.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Speicherdauer</h2>
                <p className="text-slate-600">
                  Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, 
                  verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung 
                  entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur 
                  Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich 
                  zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Änderung der Datenschutzerklärung</h2>
                <p className="text-slate-600">
                  Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
                  rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
                  Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue 
                  Datenschutzerklärung.
                </p>
              </section>

              <p className="text-slate-500 text-sm pt-4 border-t border-slate-200">
                Stand: August 2025
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default PrivacyPage;
